import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { TableContext } from '../../../../contexts/TableContext';
import EllipsisCell from '../../../../components/TableBox/Cells/EllipsisCell';
import Button from '../../../../components/Button';
import { VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';

interface SuggestionRowProps {
  item: {
    id: number;
    name: string;
    division: { id: number; name: string } | null;
  };
  className?: string;
}

const SuggestionRow: React.FC<SuggestionRowProps> = ({ item, className }) => {
  const { t } = useTranslation();
  const { headCells, rowProps } = useContext(TableContext);

  return (
    <tr className={className}>
      {headCells.map((headCell) => {
        if (headCell.id === VALIDATION_FIELD_MAPPING.name) {
          return <EllipsisCell key={headCell.id} width={headCell.width} text={item.name || '-'} />;
        }

        if (headCell.id === VALIDATION_FIELD_MAPPING.product_division) {
          return <EllipsisCell key={headCell.id} width={headCell.width} text={item.division?.name || '-'} />;
        }

        if (headCell.id === VALIDATION_FIELD_MAPPING.actions) {
          return (
            <td key={headCell.id} style={{ width: headCell.width }}>
              <Button
                className="btn btn-sm btn-outline-primary waves-effect"
                text={t('monthlyStock.addEdit.pageTexts.verifyData.table.mapModal.suggestionColumns.select')}
                onClick={() => item.division && rowProps?.onSelect(String(item.division.id), String(item.id))}
                disabled={!item.division}
              />
            </td>
          );
        }

        return null;
      })}
    </tr>
  );
};

export default SuggestionRow;
